import type { UseQueryOptions } from '@tanstack/react-query';

import { iamGetRolePrivilegeInfo } from '@crossnokaye/typescript-sdk/funcs/iamGetRolePrivilegeInfo';
import { RolePrivilegeInfo } from '@crossnokaye/typescript-sdk/models/components';
import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';
import { GetRolePrivilegeInfoResponse } from '@crossnokaye/typescript-sdk/models/operations';

import { AtlasClientFunction } from '@/client/types';

const transformRolePrivilegeInfoResponse = (
  response: GetRolePrivilegeInfoResponse
): RolePrivilegeInfo | undefined => {
  return response.rolePrivilegeInfo;
};

export interface RolePrivilegeInfoQueryProps {
  client: AtlasClientFunction;
  transform?: (response: GetRolePrivilegeInfoResponse) => RolePrivilegeInfo | undefined;
}

export const rolePrivilegeInfoQuery = ({
  client,
  transform = transformRolePrivilegeInfoResponse,
}: RolePrivilegeInfoQueryProps): UseQueryOptions<
  GetRolePrivilegeInfoResponse,
  SDKError,
  RolePrivilegeInfo | undefined
> => {
  return {
    queryKey: ['rolePrivilegeInfo'],
    queryFn: () =>
      client<undefined, GetRolePrivilegeInfoResponse>({
        atlasFunc: iamGetRolePrivilegeInfo,
      }),
    staleTime: Infinity,
    select: transform,
  };
};
